
/**
 * Shared list of hobbies and allergies for Bangladesh profiles and search filters.
 * Removed all icons/emojis for a cleaner UI as per user request.
 * Aligned with PersonalInfoSection.tsx form data.
 */

export const hobbiesList = [
  'Đọc sách',
  'Xem phim',
  'Nghe nhạc',
  'Chơi thể thao',
  'Bóng đá',
  'Bóng rổ',
  'Cầu lông',
  'Bóng chuyền',
  'Du lịch',
  'Nấu ăn',
  'Chơi game',
  'Lập trình',
  'Viết lách',
  'Chụp ảnh',
  'Vẽ tranh',
  'Đi bộ',
  'Chạy bộ',
  'Leo núi',
  'Bơi lội',
  'Cắm trại',
  'Làm vườn',
  'Câu cá',
  'Chơi cờ',
  'Học ngoại ngữ',
  'Tình nguyện',
  'Chơi nhạc cụ',
  'Sưu tầm tem',
  'Yoga',
  'Thiền',
  'Đạp xe',
  'Khiêu vũ',
  'Chăm sóc thú cưng',
  'Sửa chữa đồ đạc',
  'Thủ công (handmade)',
  'Thư pháp',
  'Hát karaoke',
];

export const allergiesList = [
  'Không có dị ứng',
  'Phấn hoa',
  'Bụi nhà',
  'Lông chó',
  'Lông mèo',
  'Nấm mốc',
  'Hải sản (chung)',
  'Tôm',
  'Cua',
  'Cá',
  'Sò / Ốc',
  'Mực',
  'Đậu phộng (lạc)',
  'Các loại hạt (óc chó, hạnh nhân...)',
  'Sữa',
  'Trứng',
  'Lúa mì (Gluten)',
  'Đậu nành',
  'Vừng',
  'Thuốc Penicillin',
  'Thuốc Aspirin',
  'Thuốc kháng sinh khác',
  'Thuốc gây tê',
  'Vết côn trùng cắn',
  'Kim loại (Niken)',
  'Mủ cao su (Latex)',
  'Ánh nắng mặt trời',
  'Thời tiết lạnh',
  'Hóa chất / Nước hoa',
];
